import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Flag, Sparkles } from 'lucide-react';

const PatrioticThemeContext = createContext({ enabled: false, toggle: () => {} });

const STORAGE_KEY = 'tca_patriotic_mode';

export const PatrioticThemeProvider = ({ children }) => {
  // Legacy patriotic theme is deprecated. Always OFF, ignore stored value.
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.classList.remove('patriotic');
    // Also purge any stale stored flag so returning visitors don't drag it back in.
    try { window.localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
  }, [enabled]);

  const toggle = useCallback(() => setEnabled((v) => !v), []);

  return (
    <PatrioticThemeContext.Provider value={{ enabled, toggle }}>
      {children}
    </PatrioticThemeContext.Provider>
  );
};

export const usePatrioticTheme = () => useContext(PatrioticThemeContext);

export const PatrioticToggle = () => {
  const { enabled, toggle } = usePatrioticTheme();
  return (
    <button
      type="button"
      className="patriotic-toggle"
      onClick={toggle}
      aria-pressed={enabled}
      data-testid="patriotic-toggle"
    >
      <span className="pt-dot" aria-hidden="true" />
      {enabled ? <Flag size={12} /> : <Sparkles size={12} />}
      {enabled ? 'USA 250 · On' : 'Patriotic Mode'}
    </button>
  );
};
